<template>
  <div class="max-w-6xl md:w-10/12 sm:w-11/12 xs:w-10/12 mx-auto my-10 px-4">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Layout",
};
</script>

